import { selectors as routerSelectors } from "../router";
import {
  ACTIVATE_ASSET_SUCCESS,
  RETURN_ASSET_SUCCESS,
  FETCH_SESSION_SUCCESS
} from "../bridge/types";
import { sendNativeMessage } from "../../ui/utils/native";

// Middleware that will re-fetch bridge session when brand loaded
export default ({ getState }) => next => action => {
  updateNativePlatform(action, getState());
  updateFraction(action);
  next(action);
};

const updateNativePlatform = (action, state) => {
  const platform = routerSelectors.getQueryParam(state, "platform");
  const isNative = routerSelectors.isNative(state);
  if (!isNative) {
    return;
  }

  switch (action.type) {
    case ACTIVATE_ASSET_SUCCESS: {
      sendNativeMessage(platform, "borrow:book", {
        isbn: action.vbid
      });
      break;
    }
    case RETURN_ASSET_SUCCESS: {
      sendNativeMessage(platform, "return:book", {
        isbn: action.vbid
      });
      break;
    }
    default:
      break;
  }
};

const updateFraction = action => {
  if (
    [
      ACTIVATE_ASSET_SUCCESS,
      RETURN_ASSET_SUCCESS,
      FETCH_SESSION_SUCCESS
    ].indexOf(action.type) !== -1
  ) {
    window.dispatchEvent(
      new CustomEvent("fraction-data-update", {
        detail: { ...action }
      })
    );
  }
};
